<form
  [formGroup]="poamendmentForm"
  (ngSubmit)="onSubmit()"
  class="b1-form p-6 bg-white rounded-lg shadow-md"
>
  <h1 class="text-xl font-semibold mb-4">Amend purchase order</h1>
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-6">
      <mat-label>Original purchase order</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-select formControlName="originalPoId" (selectionChange)="onPoChange($event.value)">
          <mat-option *ngFor="let po of purchaseOrders" [value]="po.id">
            {{ po.po_ref || ('PO #' + po.id) }} · {{ po.project_name }} ({{ po.po_status }})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Amendment type</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-select formControlName="amendmentType">
          <mat-option value="Value change">Value change</mat-option>
          <mat-option value="Quantity Change">Quantity change</mat-option>
          <mat-option value="Price Change">Price change</mat-option>
          <mat-option value="Item Addition">Item addition</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-span-12">
      <mat-label>Reason for amendment</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="reasonForAmendment" rows="2"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Revised quantity</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="revisedQuantity" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Revised unit price</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="revisedUnitPrice" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Revised total value</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="revisedTotalValue" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Authorized by</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="authorizedBy" />
      </mat-form-field>
    </div>
  </div>
  <div class="mt-6 flex gap-4">
    <button mat-raised-button color="primary" type="submit" [disabled]="saving || poamendmentForm.invalid">
      Apply amendment
    </button>
    <button mat-button type="button" (click)="onReset()">Reset</button>
  </div>
</form>
